export default "__VITE_ASSET__EzsfluUB__"